let viewerCleanup = null;

export function openAttachmentViewer(url, title = "Allegato") {
  viewerCleanup?.();

  const overlay = document.createElement("div");
  overlay.setAttribute("role", "dialog");
  overlay.setAttribute("aria-modal", "true");
  overlay.style.cssText = "position:fixed;inset:0;z-index:9999;background:#f8fafc;display:flex;flex-direction:column";

  const header = document.createElement("div");
  header.style.cssText = "height:60px;flex:0 0 60px;background:#fff;border-bottom:1px solid #dbe2ea;display:flex;align-items:center;justify-content:space-between;gap:12px;padding:8px 12px;box-shadow:0 1px 4px rgba(15,23,42,.08)";

  const heading = document.createElement("strong");
  heading.textContent = title || "Allegato";
  heading.style.cssText = "min-width:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;color:#0f172a;font:600 15px system-ui,sans-serif";

  const close = document.createElement("button");
  close.type = "button";
  close.textContent = "← Chiudi e torna al gestionale";
  close.style.cssText = "flex:0 0 auto;border:0;border-radius:8px;background:#0f172a;color:#fff;padding:10px 14px;font:600 14px system-ui,sans-serif;cursor:pointer";

  const isImage = /\.(?:jpe?g|png|webp|gif)(?:[?#].*)?$/i.test(url);
  let content;
  if (isImage) {
    content = document.createElement("div");
    content.style.cssText = "min-height:0;flex:1;overflow:auto;background:#eef2f6;display:flex;align-items:center;justify-content:center;padding:16px";
    const image = document.createElement("img");
    image.src = url;
    image.alt = title || "Foto";
    image.style.cssText = "display:block;width:auto;height:auto;max-width:100%;max-height:100%;object-fit:contain;margin:auto;box-shadow:0 4px 20px rgba(15,23,42,.15)";
    content.appendChild(image);
  } else {
    content = document.createElement("iframe");
    content.src = url;
    content.title = title || "Allegato";
    content.style.cssText = "width:100%;height:calc(100% - 60px);border:0;background:#fff;flex:1";
  }

  header.append(heading, close);
  overlay.append(header, content);
  document.body.appendChild(overlay);
  const previousOverflow = document.body.style.overflow;
  document.body.style.overflow = "hidden";

  let pushed = false;
  let closed = false;
  const cleanup = () => {
    if (closed) return;
    closed = true;
    window.removeEventListener("popstate", onPopState);
    document.removeEventListener("keydown", onKeyDown);
    overlay.remove();
    document.body.style.overflow = previousOverflow;
    viewerCleanup = null;
  };
  const onPopState = () => cleanup();
  const onKeyDown = (event) => {
    if (event.key === "Escape") closeViewer();
  };
  const closeViewer = () => {
    if (pushed) window.history.back();
    else cleanup();
  };

  close.addEventListener("click", closeViewer);
  window.addEventListener("popstate", onPopState);
  document.addEventListener("keydown", onKeyDown);
  window.history.pushState({ cantiereproAttachment: true }, "");
  pushed = true;
  viewerCleanup = cleanup;
}
